import { render } from "./Lot.vue?vue&type=template&id=5cf2b8f2"
import script from "./Lot.vue?vue&type=script&lang=js"
export * from "./Lot.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__